import { render, staticRenderFns } from "./FactsCarousel.vue?vue&type=template&id=6d8ea328&scoped=true&"
import script from "./FactsCarousel.vue?vue&type=script&lang=js&"
export * from "./FactsCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d8ea328",
  null
  
)

export default component.exports